import { Button } from "@mui/material";
import CommentIcon from "@mui/icons-material/Comment";
import type { EditableCallbackParams } from "ag-grid-community";
import { useState } from "react";
import { EditWorkOrderModal } from "@/shared/work-orders-modals/components/modal-edit-work-order";
import { ErrorModal } from "@dexteel/mesf-core";
import Grid2 from '@mui/material/Grid2';

type Props = {
	params: EditableCallbackParams;
	searchData: Function;
};

export const WorkOrdersCommentsColumn = ({ params, searchData }: Props) => {
	const [openGridEditDialog, setOpenGridEditDialog] = useState<boolean>(false);
	const [error, setError] = useState<string>("");

	if (params.data.id !== -1) {
		return (
			<>
				<Grid2 spacing={1}
					style={{ alignItems: "center" }}>
					<Grid2 size={{ xs: 12, md: 12 }}>
						<Button
							onClick={() => setOpenGridEditDialog(true)}
							fullWidth
							color="primary"
							style={{
								textDecoration: "none",
								fontWeight: 500,
								fontSize: "12px",
								borderRadius: "3px",
								marginRight: 8,
							}}
							title={
								params.data?.Comments
									? `${(params.data?.Comments).substr(0, 50)}...`
									: ""
							}
							disabled={!params.data?.Comments}>
							<CommentIcon />
						</Button>
					</Grid2>
				</Grid2>
				<EditWorkOrderModal
					show={openGridEditDialog}
					data={params.data as any}
					onHide={(shouldUpdate: boolean) => {
						if (shouldUpdate) {
							searchData();
						}
						setOpenGridEditDialog(false);
					}} />
				<ErrorModal error={error} onHide={() => setError("")} />
			</>
		);
	} else return <></>;
};
